<div class="row">
    @if (model$ | async) {
        <div class="card">
            <h5 class="card-header">Inventory Count Status | {{ model.current.countDate | date: 'shortDate' }}</h5>
            <table class="table">
                <tbody>
                    <tr>
                        <td>Scheduled</td>
                        <td>
                            <a class="detail" (click)="linkClick(0, 0)">{{ model.current.scheduled }}</a>
                        </td>
                        <td>--</td>
                    </tr>
                    <tr>
                        <td>Pending</td>
                        <td>
                            <a class="detail" (click)="linkClick(0, 1)">{{ model.current.pending }}</a>
                        </td>
                        <td>{{ model.current.percentIncomplete }}%</td>
                    </tr>
                    <tr>
                        <td>Completed</td>
                        <td>
                            <a class="detail" (click)="linkClick(0, 2)">{{ model.current.completed }}</a>
                        </td>
                        <td>{{ model.current.percentComplete }}%</td>
                    </tr>
                </tbody>
            </table>
        </div>
    }

    @if (model$ | async) {
        <div class="card">
            <h5 class="card-header">Inventory Count Status | {{ model.previous.countDate | date: 'shortDate' }}</h5>
            <table class="table">
                <tbody>
                    <tr>
                        <td>Scheduled</td>
                        <td>
                            <a class="detail" (click)="linkClick(1, 0)">{{ model.previous.scheduled }}</a>
                        </td>
                        <td>--</td>
                    </tr>
                    <tr>
                        <td>Missed</td>
                        <td>
                            <a class="detail" (click)="linkClick(1, 3)">{{ model.previous.missed }}</a>
                        </td>
                        <td>{{ model.previous.percentIncomplete }}%</td>
                    </tr>
                    <tr>
                        <td>Completed</td>
                        <td>
                            <a class="detail" (click)="linkClick(1, 2)">{{ model.previous.completed }}</a>
                        </td>
                        <td>{{ model.previous.percentComplete }}%</td>
                    </tr>
                </tbody>
            </table>
        </div>
    }
</div>
